<template>
  <div class="imgPreview" v-show='display'>
      <div class="img-wrap" >

        <div class="imgBox">
          <img :src='img' class="img"/>
          <img @click='closeImg' class="close" src='../assets/images/close.png'/>
        </div>
        
      </div>
  </div>  
</template>

<script>
export default {
  name:'',
  props: ['img','display'],
  data() {
    return {

    }
    
  },
  mounted(){
  },
  methods:{
    init(){
      // const self = this;
      // self.$refs.imgbox.style.offsetWidth = document.body.clientWidth;
      // self.$refs.imgbox.style.offsetHeight = document.body.clientHeight;
      // console.log(self.$refs.imgbox.style.offsetWidth,self.$refs.imgbox.style.offsetHeight);
    },
    closeImg(){
      this.$emit('close',1);
    }
  }
}
</script>

<style>
.imgPreview{
  width: 100%;
  height: 100%;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 9999;
  background-color: rgba(0,0,0,0.4);
}
.img-wrap{
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
}
.imgBox{
  position: relative;
}
.close{
  cursor: pointer;
  position: absolute;
  top: -22px;
  right: -38px;
}
.img{
  max-width: 800px;
  max-height: 600px;
}
</style>



// WEBPACK FOOTER //
// src/components/imgPreview.vue